/**
 * Downloads a payload
 * @param blobParts File content, can just be ["stringpayload"]
 * @param contentType File content type
 * @param filename Filename to download to
 */
export function downloadFile(blobParts: BlobPart[], contentType: string, filename: string) {
  const blob = new Blob(blobParts, { type: contentType })
  const blobURL = URL.createObjectURL(blob)
  const a = document.createElement('a')

  a.setAttribute('href', blobURL)
  a.setAttribute('download', filename)
  a.click()

  URL.revokeObjectURL(blobURL)
}
